import { Button } from "@svea/design-system-components-react";
import { useIdleTimer } from "../../hooks/idle-timer";
import { useText } from "../../hooks/lang";
import { ButtonGroup } from "../button-group";
import { Dialog } from "../dialog/dialog";

type Props = {
	onLogout: () => void;
	timeToWarning: number;
	timeToLogout: number;
};

export const IdleLogoutModal = ({ onLogout, timeToLogout, timeToWarning }: Props) => {
	const { hasIdleWarning, resetIdleWarning } = useIdleTimer({
		onLogout,
		timeToWarning,
		timeToLogout,
	});

	const [t, texts] = useText();

	return (
		<Dialog
			isDismissable={false}
			isOpen={hasIdleWarning}
			center
			size="small"
			heading={t(texts.loginPage.logoutModal.heading)}
			aria-live="assertive"
		>
			<Dialog.Content>{t(texts.loginPage.logoutModal.body)}</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button width="full" onPress={() => onLogout()}>
						{t(texts.common.logout)}
					</Button>
					<Button
						width="full"
						variant="secondary"
						onPress={() => {
							resetIdleWarning();
						}}
					>
						{t(texts.loginPage.logoutModal.stay)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
